import { render, staticRenderFns } from "./kalemdokumanlar.vue?vue&type=template&id=0bf8fab6&"
import script from "./kalemdokumanlar.vue?vue&type=script&lang=js&"
export * from "./kalemdokumanlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports